// @ts-check
import React, { PureComponent } from 'react';
import sanitizeUnits from 'scr/sanitizeUnits';

/**
 * @typedef {{
 *  units: redux.store['projectFor3d']['units'];
 *  onChange: react.components.utils.UnitsInputv2OnChange;
 *  className?: className<'input'>;
 *  value: UnitsInputv2Value;
 * }} Props
 */

/** @augments { PureComponent<Props> } */
export class UnitsInputv2 extends PureComponent {
  onChange = (
    /** @type { React.ChangeEvent<HTMLInputElement> } */
    { target: { value } }
  ) => {
    const { units, onChange } = this.props;
    const rez = sanitizeUnits(
      units,
      /** @type { UnitsInputv2Value } */ ( value )
    );

    if( !rez.isValid ) return;

    onChange( rez.value );
  };

  onBlur = () => {
    const { onBlur } = this.props;

    if( onBlur ) {
      onBlur();
    }
  };

  handleKeyDownEnter = ( e ) => {
    const { onBlur } = this.props;

    if( onBlur && e.keyCode === 13 ) {
      onBlur();
    }
  };

  render() {
    const {
      props: { className = '', value, ...rest }
    } = this;

    return (
      <input { ...{
        ...rest,
        value,
        type: 'text',
        onChange: this.onChange,
        onBlur: this.onBlur,
        onKeyDown: this.handleKeyDownEnter,
        className: `${ className } unitsInput`
      } }
      />
    );
  }

}
